export const sameAsTypes = {
  ARTSDATA_IDENTIFIER: 'ArtsdataIdentifier',
  FOOTLIGHT_IDENTIFIER: 'FootlightIdentifier',
};
